import logo from '../assets/logo.png';
import italianflag from '../assets/italy.png';
import usaflag from '../assets/united-states.png'
import java from '../assets/java.png';
import golang from '../assets/golang.png';
import javascript from '../assets/javascript.png';
import python from '../assets/python.png';
import reactjs from '../assets/reactjs.png';
import postman from '../assets/postman.png';
import bootstrap from '../assets/bootstrap.png';
import github from '../assets/github.png';
import gitlab from '../assets/gitlab.png';
import mysql from '../assets/mysql.png';
import nodejs from '../assets/nodejs.png';
import postgresql from '../assets/postgresql.png';
import photoshop from '../assets/photoshop.png';
import css from '../assets/css.png';
import html from '../assets/html.png';
import scss from '../assets/scss.png';
import marvel from '../assets/marvel.png';
import mongodb from '../assets/mongodb.png';
import express from '../assets/express.png';
import php from '../assets/php.png';
import me from '../assets/me.jpg';
import generocity from '../assets/generocity.png';
import lucciolalegnami from '../assets/lucciolalegnami.png';
import quizart from '../assets/quizart.png';
import babel from '../assets/babel.jpg';
import biometricbites from '../assets/biometricbites.png';
import strokeprediction from '../assets/strokeprediction.png';
import autonomousnetworking from '../assets/autonomousnetworking.png';
import airbnb from '../assets/airbnb.png';
import voicefork from '../assets/voicefork.png';
import voiceforkskill from '../assets/voicefork-skill.png';
import docker from '../assets/docker.png';
import k6 from '../assets/k6.png';
import reactnative from '../assets/reactnative.png';
import scikitlearn from '../assets/scikitlearn.png';
import spark from '../assets/spark.png';
import terraform from '../assets/terraform.png';
import typescript from '../assets/typescript.png';
import django from '../assets/django.png';
import aws from '../assets/aws.png';
import melanoma from '../assets/melanoma.png';
import hardhat from '../assets/hardhat.png';
import solidity from '../assets/solidity.png';
import pytorch from '../assets/pytorch.png';
import smartsupply from '../assets/smartsupply.png';
import tailwind from '../assets/tailwind.png';
import sentimentanalysis from '../assets/sentimentanalysis.png';
import eegpersonalityestimation from '../assets/eegpersonalityestimation.png';
import explorerstale from '../assets/explorerstale.png';
import nextjs from '../assets/nextjs.png';
import strapi from '../assets/strapi.png';
import graphql from '../assets/graphql.png';
import steamrecommender from '../assets/steamrecommender.png';
import reachabilitygame from '../assets/reachabilitygame.png';
import fastapi from '../assets/fastapi.png';

export default {
    logo,
    italianflag,
    usaflag,
    java,
    golang,
    javascript,
    python,
    reactjs,
    postman,
    bootstrap,
    gitlab,
    github,
    mysql,
    nodejs,
    postgresql,
    photoshop,
    css,
    html,
    scss,
    marvel,
    mongodb,
    express,
    php,
    me,
    generocity,
    lucciolalegnami,
    quizart,
    babel,
    biometricbites,
    strokeprediction,
    autonomousnetworking,
    airbnb,
    voicefork,
    voiceforkskill,
    docker,
    k6,
    reactnative,
    scikitlearn,
    spark,
    terraform,
    typescript,
    django,
    aws,
    melanoma,
    hardhat,
    solidity,
    pytorch,
    smartsupply,
    tailwind,
    sentimentanalysis,
    eegpersonalityestimation,
    explorerstale,
    nextjs,
    strapi,
    graphql,
    steamrecommender,
    reachabilitygame,
    fastapi
};